<template>
  <div>
    <div id="player_container" 
      :class='isSmallerDevice(768) ? "smaller-screen" : ""'
    ></div>
  </div>
</template>


<script>
import 'flowplayer/dist/skin/skin.css'
import $ from 'jquery'
import flowplayer from 'flowplayer'
import engine from 'flowplayer-hlsjs';

import { flowplayerKey } from '../app/config.js'
import { authRequest, log } from '../app/helpers'

export default {

  props: {
    src: String,
    title: String,
    subtitle: String,
    id: Number,
    time: String,
    type: String,
    autoPlay: {
      type: Boolean,
      default: true
    },
    updatePlayTime: {
      type: Boolean,
      default: true
    },
    updatePlayTimeUrl: {
      type: String,
      default: '/playtime'
    },
    isLive: {
      type: Boolean,
      default: false
    },
  },

  data() {

    return {
      oldTime: null,
    }

  },


  mounted() {
    const player = this.playVideo();
    console.log('flow player');
    this.updateTime(player);
  },

  methods: {
    playVideo() {
      if (this.isLive) {
        engine(flowplayer);
      }

      const self = this;
      const player = flowplayer("#player_container", { 
        key: flowplayerKey,
        autoplay: self.autoPlay,
        // hlsjs: {
        //   // bufferWhilePaused: self.isLive ? false : true,
        // },
        // splash: true,
        clip: { 
          // SOURCES 
          title: self.title,
          sources: [ 
            { 
              type: self.isLive ? 'application/x-mpegurl' : "video/mp4", 
              src: self.src 
            } 
          ],
          // subtitles: [
          //     { 
          //       default: true, // note the quotes around "default"!
          //       kind: "subtitles", 
          //       srclang: "en", 
          //       label: "English",
          //       src:  '' 
          //     }
          // ],
        } 
      }).on('resume', (e) => {
        self.updateTime(player)
      }).on('ready', (e, api, video) => {
        // http://demos.flowplayer.org/api/starttime.html#t={seconds}
        if (self.time == null) {
          return true;
        }

        let hash = self.time,
            pos = hash.substr(3);

        if (hash.indexOf("#t=") === 0 && !isNaN(pos)) {
          // 1 decimal precision
          pos = Math.round(parseFloat(pos) * 10) / 10;
          
          if (pos < video.duration) {
            api.seek(pos);
          }
        }
      });

      log('flowplyer', player);

      return player;
    },


    updateTime(player) {
      if (!this.updatePlayTime) {
        return false;
      }

      const self = this;
      
      const timer = setInterval(async function(){ 
        let pos = player.video.time;
        let hash = pos && !isNaN(pos) ? 
          "t=" + (Math.round(pos * 10) / 10) : 
          "";
        let duration = player.video.duration;
        
        log('oldtime', self.oldTime);
        log('hash', hash);

        if (self.oldTime != hash) {
          self.oldTime = hash;
          
          let q = {};
          q.time = hash;
          q.id = self.id;
          q.duration = duration;
          q.type = self.type;

          log('updatetime:', q);

          const req = await authRequest(
            self.$router,
            self.updatePlayTimeUrl,
            q,
            'post'
          );

          log('time updated ', req)
        } else {
          log('removing interval')
          clearInterval(timer)
        }
      }, 5000);
    }


  }
}
</script>



<style lang="scss">
.flowplayer {
  height: 500px;
  
  &.smaller-screen {
    height: 300px;
  }
}
/* waiting element with custom graphic */
.flowplayer .fp-waiting {
  background: url('../assets/Ripple-1.2s-187px.svg') no-repeat center center;
  height: 100%;
  display: none;
}
.flowplayer.is-loading .fp-waiting,
.flowplayer.is-seeking .fp-waiting {
  display: block;
}
.flowplayer .fp-waiting svg {
  height: 0;
}

.flowplayer .fp-color {
    background-color: #dc3e44;
}
</style>